import React, { lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';
import { hasValue } from 'globalutils/fmUtils';
import useInitilaValues from './useInitilaValues';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const PoliciesForm = ({
  apiStatus,
  submitPoliciesAndProcedures,
  history,
  Styled,
  policies,
  uploadLogo,
  downloadDocument,
  policyDownload,
  logBook,
  deleteLogo,
  clearState,
  saveCustomPolicy,
  editCustomPolicy,
  customPolicy,
  fetchCustomPolicy,
  handleDeleteCustomPolicyAlert,
  downloadCustomPolicy,
  callback,
}) => {
  const apiId = 'policyform';
  const hasApiStatus = hasValue(apiStatus.status, 'api', apiId);
  const beBaseUrl = window?.$environment?.BE_BASE_URL;

  const { initialValues } = useInitilaValues({ policies });

  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  useEffect(() => {
    let url = policyDownload ? `${beBaseUrl}/${policyDownload}` : '';
    if (typeof policyDownload === 'string') document.getElementById(`policyDocument`).src = url;
  }, [policyDownload]);

  const fileUpload = (fields) => {
    if (fields.file === undefined) {
      deleteLogo({
        data: {
          id: policies.fileId,
        },
        deleteApiId: 'deleteLogo',
      });
    } else {
      if (fields.file && fields.file[0].name !== policies.fileName) {
        const request = {
          type: 'COMPANY_LOGOTYPE',
          editUpload: false,
          name: fields.file[0].name,
          doctype: 'LOGOTYPE',
          id: policies.fileId,
        };
        uploadLogo({
          data: {
            data: {
              file: fields.file[0],
              request: JSON.stringify(request),
            },
          },
          uploadApiId: 'uploadLogo',
          callback: policyCallback,
        });
      }
    }
  };

  const policyCallback = () => {
    window.location.reload();
  };

  const hanldeSubmit = (fields) => {
    fileUpload(fields);
    submitPoliciesAndProcedures({
      data: {
        policyTypes: fields.policyTypes,
        policiesIds: fields.policiesIds,
        policyParameters: {
          ...fields.policyParameters,
          ALLOW_USING_PHONES: fields.policyParameters.ALLOW_USING_PHONES ? 'ALLOW_USING_PHONES' : null,
        },
      },
      apiId,
      callback:
        fields.file === undefined || (fields.file && fields.file[0].name !== policies.fileName)
          ? null
          : () => window.location.reload(),
      fields: fields,
    });
  };

  return (
    <Styled.Wrapper>
      <div className="formLogin">
        <Form
          type="server"
          direction="column"
          RenderComponent={RenderComponent}
          initialValues={initialValues}
          handleOnSubmit={hanldeSubmit}
          customProps={{
            hasApiStatus,
            history,
            Styled,
            policies,
            downloadDocument,
            logBook,
            saveCustomPolicy,
            editCustomPolicy,
            customPolicy,
            handleDeleteCustomPolicyAlert,
            callback,
            fetchCustomPolicy,
            downloadCustomPolicy,
          }}
        />
      </div>
      <iframe title="policyDocument" id="policyDocument" style={{ display: 'none' }}></iframe>
    </Styled.Wrapper>
  );
};
export default PoliciesForm;

PoliciesForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  submitPoliciesAndProcedures: PropTypes.func.isRequired,
  history: PropTypes.object,
};
